import { common } from '../../main/common-sidecar'
import { EGeneralCommand } from './multi/voyageMessageGeneralCommand'
import { voyageMessageGeneralCommand } from './multi/voyageMessageGeneralCommand-sidecar'

import { voyageGameMode_bodyAlign } from './voyageGameMode_bodyAlign-sidecar'
import { voyageGameMode_editor } from './voyageGameMode_editor-sidecar'
import { voyageGameMode_game } from './voyageGameMode_game-sidecar'
import { voyageGameMode_loading } from './voyageGameMode_loading-sidecar'
import { voyageGameMode_menuMain } from './voyageGameMode_menuMain-sidecar'

export type VoyageGameModeType =
  | 'init'
  | 'loading'
  | 'main-menu'
  | 'game'
  | 'editor'
  | 'body-align'

export interface IVoyageGameModeManager {
  isPaused: boolean
  generator: Generator<number, number, number> | null
  generator_exit: (() => void) | null
  generatorPauseSeconds: number
  mode: VoyageGameModeType
}

let _obj: IVoyageGameModeManager | null = null
export function get() {
  if (!_obj) {
    _obj = create()
  }
  return _obj
}

export function togglePause() {
  voyageMessageGeneralCommand.sendMessageAndImmediatelyExecute({
    command: get().isPaused ? EGeneralCommand.Unpause : EGeneralCommand.Pause,
  })
}

export function networkPause(isPaused: boolean) {
  get().isPaused = isPaused
}

function create() {
  let obj: IVoyageGameModeManager = {
    generator: null,
    generator_exit: null,
    generatorPauseSeconds: 0,
    isPaused: false,
    mode: 'init',
  }
  return obj
}

export function update() {
  let obj = get()

  let ds = common.getUpdateDeltaScaled()

  if (obj.generatorPauseSeconds > 0) {
    obj.generatorPauseSeconds -= ds
    return
  }

  if (obj.generator) {
    let generatorResult = obj.generator.next()
    if (generatorResult.done) {
      console.log('Generator is done!')
    } else {
      obj.generatorPauseSeconds = generatorResult.value
    }
  }
}

function switchMode(
  newMode: VoyageGameModeType,
  generator: Generator<number, number, number> | null,
  generatorExit: () => void = () => {},
) {
  let obj = get()
  exitCurrentMode()
  obj.mode = newMode
  obj.generator = generator
  obj.generator_exit = generatorExit
}

function exitCurrentMode() {
  let obj = get()
  if (obj.generator_exit) {
    obj.generator_exit()
    obj.generator_exit = null
  }
}

export function goLoading() {
  switchMode('loading', voyageGameMode_loading.generator_loading())
}
export function goMenuMain() {
  switchMode('main-menu', voyageGameMode_menuMain.generator_menuMain())
}
export function goEditor() {
  switchMode('editor', voyageGameMode_editor.generator_editor())
}
export function goBodyAlign() {
  switchMode('body-align', voyageGameMode_bodyAlign.generator_bodyAlign())
}
export function goGame() {
  switchMode('game', voyageGameMode_game.generator_game())
}
